var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"sso-btn text-capitalize",attrs:{"block":"","outlined":"","large":""},on:{"click":function($event){return _vm.$emit( 'click' )}}},[_c('span',{class:[ 'sso-icon', `${_vm.provider.name}-icon`, 'mr-2' ]}),_vm._v(" "+_vm._s(_vm.$t( 'message.ContinueWith'))+" "+_vm._s(_vm.provider.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }